import React, { useEffect, useRef } from "react"
import PropTypes from "prop-types"
import { renderTemplateForm } from "@infotech/widget-report-generator/bundle"

const TemplateForm = ({
  templateCode,
  onDeleted,
  onCanceled,
  getToken,
  reportServiceUrl,
  filesServiceUrl,
  requiredTags,
  securityServiceURL,
}) => {
  const root = useRef(null)

  useEffect(() => {
    renderTemplateForm(
      root.current,
      {
        env: {
          REPORT_SERVICE: reportServiceUrl,
          FILES_SERVICE: filesServiceUrl,
          SECURITY_SERVICE: securityServiceURL,
        },
        getToken,
      },
      {
        templateCode,
        onDeleted,
        onCanceled,
        requiredTags,
      },
    )
  }, [])

  return <div ref={root} />
}

TemplateForm.propTypes = {
  templateCode: PropTypes.string,
  onDeleted: PropTypes.func.isRequired,
  onCanceled: PropTypes.func.isRequired,
  getToken: PropTypes.func.isRequired,
  reportServiceUrl: PropTypes.string.isRequired,
  filesServiceUrl: PropTypes.string.isRequired,
  securityServiceURL: PropTypes.string.isRequired,
  requiredTags: PropTypes.arrayOf(PropTypes.string).isRequired,
}

TemplateForm.defaultProps = {
  templateCode: undefined,
}

export default TemplateForm
